$(document).ready(function() {
  if($( window ).width() <= 768 ){
    $('.product_slide_wrap,.product-slider').contents().unwrap();
  }
  if($(window).width() > 768 ){
    //   slick 
    $('.product-slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true
    });
  }
  
});


// $(window).resize(function(){
//   location.reload();
// });
class ProductFormElement extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.addToCart = this.querySelector('[type="submit"], .add-to-cart');

    if (this.form) {
      this.form.addEventListener('submit', this.addItemFromForm.bind(this));
    }
  }

  addItemFromForm(evt) {
    evt.preventDefault();
    if (this.loading) return;

    this.addToCart?.classList.add('btn--loading');
    this.loading = true;

    const variantId = this.form.querySelector('[name="id"]').value;
    const qty = this.form.querySelector('[name="quantity"]')?.value || 1;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 422) {
          this.error(data);
        } else {
          this.success(data);
        }
      })
      .catch(err => {
        this.error({ description: err.message });
      })
      .finally(() => {
        this.loading = false;
        this.addToCart?.classList.remove('btn--loading');
      });
  }

  success(product) {
    let errors = this.form.querySelector('.errors');
    if (errors) errors.remove();

    document.dispatchEvent(
      new CustomEvent('ajaxProduct:added', {
        detail: { product, addToCartBtn: this.addToCart }
      })
    );
  }

  error(error) {
    if (!error.description) {
      console.warn(error);
      return;
    }

    let errors = this.form.querySelector('.errors');
    if (errors) errors.remove();

    let errorDiv = document.createElement('div');
    errorDiv.classList.add('errors', 'text-center');
    errorDiv.textContent = error.description;
    this.form.append(errorDiv);
    setTimeout(() => {
      errorDiv.remove();
    }, 5000);

    document.dispatchEvent(
      new CustomEvent('ajaxProduct:error', {
        detail: { errorMessage: error.description }
      })
    );
  }
}

customElements.define('product-form-card', ProductFormElement);


class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.loading = false;
    this.page = Number(this.dataset.page || 1);
    this.pages = Number(this.dataset.pages || 1);

    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.loadMore();
        }
      },
      {
        rootMargin: '500px'
      }
    );
  }

  connectedCallback() {
    if (this.page >= this.pages) {
      this.remove();
      return;
    }

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  async loadMore() {
    if (this.loading || this.page >= this.pages) return;

    this.loading = true;
    this.classList.add('loading');

    try {
      const nextPage = this.page + 1;

      const url = new URL(window.location.href);

      url.searchParams.set('page', nextPage);

      const response = await fetch(url.toString());

      if (!response.ok) {
        throw new Error(`Failed to load page ${nextPage}`);
      }

      const html = await response.text();

      const doc = new DOMParser().parseFromString(
        html,
        'text/html'
      );

      const currentGrid = document.querySelector(
        '#CollectionSection .grid'
      );

      const nextGrid = doc.querySelector(
        '#CollectionSection .grid'
      );

      if (!currentGrid || !nextGrid) {
        throw new Error('Grid not found');
      }

      currentGrid.insertAdjacentHTML(
        'beforeend',
        nextGrid.innerHTML
      );

      this.page = nextPage;

      if (this.page >= this.pages) {
        this.observer.disconnect();
        this.remove();
      }
    } catch (error) {
      console.error('Infinite scroll error:', error);
    }

    this.loading = false;
    this.classList.remove('loading');
  }
}

customElements.define(
  'infinite-scroll',
  InfiniteScroll
);